<span class="appName" *ngFor="let word of inputValue.split(' '); let i=index" [style]="styleString" [class]="classString"  >
    <span *ngIf="foreColor=='black'" [ngClass]="{'prismB': word === 'PRISM', 'pdm': word === 'PdM'}" >{{word}}</span>
    <span *ngIf="foreColor=='white'" [ngClass]="{'prismW': word === 'PRISM', 'pdm': word === 'PdM'}" >{{word}}</span>
	<span *ngIf="(i !== inputValue.split(' ').length - 1) && word !== 'PRISM'">&nbsp;</span>
</span>

